"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformEvaluationVisitorAdapter = void 0;
const NodeEvaluationVisit_1 = require("./nodeEvaluation/NodeEvaluationVisit");
const TransitionVisitor_1 = require("./TransitionVisitor");
class TransformEvaluationVisitorAdapter extends TransitionVisitor_1.TransitionVisitor {
    nodeEvaluationVisit;
    constructor(answerResolver, evalVisitor, extractRule) {
        super();
        this.nodeEvaluationVisit = new NodeEvaluationVisit_1.NodeEvaluationVisit(answerResolver, evalVisitor, extractRule);
    }
    visitQuestionnaire(questionnaire) {
        return super.visitQuestionnaire(questionnaire);
    }
    visitSectionGroup(sectionGroup) {
        this.nodeEvaluationVisit.visitFor(sectionGroup, () => super.visitSectionGroup(sectionGroup), {
            nodeType: NodeEvaluationVisit_1.NodeType.SectionGroup,
            repeatedInstanceIdentifiers: sectionGroup.metadata.repeatedInstanceIdentifierContext,
        });
    }
    visitSection(section) {
        this.nodeEvaluationVisit.visitFor(section, () => super.visitSection(section), {
            nodeType: NodeEvaluationVisit_1.NodeType.Section,
            repeatedInstanceIdentifiers: section.metadata.repeatedInstanceIdentifierContext,
        });
    }
    visitSubsection(subsection) {
        this.nodeEvaluationVisit.visitFor(subsection, () => super.visitSubsection(subsection), {
            nodeType: NodeEvaluationVisit_1.NodeType.Subsection,
            repeatedInstanceIdentifiers: subsection.metadata.repeatedInstanceIdentifierContext,
        });
    }
    visitFieldGroup(fieldGroup) {
        this.nodeEvaluationVisit.visitFor(fieldGroup, () => super.visitFieldGroup(fieldGroup), {
            nodeType: NodeEvaluationVisit_1.NodeType.FieldGroup,
            repeatedInstanceIdentifiers: fieldGroup.metadata.repeatedInstanceIdentifierContext,
        });
    }
    visitField(field) {
        this.nodeEvaluationVisit.visitFor(field, () => super.visitField(field), {
            nodeType: NodeEvaluationVisit_1.NodeType.Field,
            repeatedInstanceIdentifiers: field.metadata.repeatedInstanceIdentifierContext,
        });
    }
    visitOption(option) {
        this.nodeEvaluationVisit.visitFor(option, () => super.visitOption(option), {
            nodeType: NodeEvaluationVisit_1.NodeType.Option,
            repeatedInstanceIdentifiers: option.metadata.repeatedInstanceIdentifierContext,
        });
    }
}
exports.TransformEvaluationVisitorAdapter = TransformEvaluationVisitorAdapter;
